import { FunctionComponent } from 'react'
import { ReactComponent as TextIcon } from 'assets/icons/alignLeft16.svg'
import { ReactComponent as CountIcon } from './icons/word-count__16.svg'
import { ReactComponent as ClockIcon } from './icons/timestamp__16.svg'
import { DefaultType } from 'api/clients/PropertyClient'
import {
  AlignLeft,
  Calendar2,
  CalendarCheck,
  Document,
  Hash2,
  LinkAngled,
  MultiSelect,
  SingleSelect,
  Task,
  TextInput,
  UserProfile,
} from 'blaze-ui/icons'

export interface Props {
  type: string
  defaultType?: DefaultType | null
}

interface PropertyIconsInterface {
  [key: string]: FunctionComponent<any>
}

export const BlazePropertyIcons: PropertyIconsInterface = {
  title: TextInput,
  owner: UserProfile,
  created: Calendar2,
  updated: Calendar2,
  wordcount: CountIcon,
  default: TextIcon,
  link: LinkAngled,
  number: Hash2,
  person: UserProfile,
  date: CalendarCheck,
  document: Document,
  multi_select: MultiSelect,
  single_select: SingleSelect,
  text: AlignLeft,
  status: ClockIcon,
  checkbox: Task,
  posts: CalendarCheck,
}

const PropertyIcon = ({ type, defaultType }: Props) => {
  let Icon = BlazePropertyIcons['text']
  if (BlazePropertyIcons[type]) Icon = BlazePropertyIcons[type]
  if (defaultType && BlazePropertyIcons[defaultType]) Icon = BlazePropertyIcons[defaultType]

  return <Icon />
}

const _PropertyIcon = (props: Props) => {
  return <PropertyIcon {...props} />
}

export default _PropertyIcon
